import script from "./TableStatusSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableStatusSelect.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__